import gql from "graphql-tag";

export const DELETE_TEMPLATE_COSTUME_ATTRIBUTE = gql`
  mutation DeleteCostumeAttribute($filter: UniqCostumeAttributeFilterInput!) {
    deleteCostumeAttribute(filter: $filter) {
      id
    }
  }
`;
